import { markThreadAsReadMutation } from "@/app/Threads/GraphQL/threadMutations";
import { useThreadMutation } from "@/app/Threads/hooks/useThreadMutation";

export function useMarkThreadAsRead() {
  return useThreadMutation(markThreadAsReadMutation, { isRowAction: false });
}
